import { render, staticRenderFns } from "./DisableDeclarationDialog.vue?vue&type=template&id=39c37b82&scoped=true&"
import script from "./DisableDeclarationDialog.vue?vue&type=script&lang=ts&"
export * from "./DisableDeclarationDialog.vue?vue&type=script&lang=ts&"
import style0 from "./DisableDeclarationDialog.vue?vue&type=style&index=0&id=39c37b82&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c37b82",
  null
  
)

export default component.exports